import { Component, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { UIModel } from '../../../../models/core/ui/ui.model';
import { GlobalErrorHandler } from '../../../../services/error.handler';

@Component({
  selector: 'app-internal-error',
  templateUrl: './internal-error.component.html',
  styleUrls: ['./internal-error.component.scss']
})
export class InternalErrorComponent implements OnInit {

  /**
   * Gets or sets animation options for lottie.
   */
  public animationOptions: AnimationOptions = {
    path: UIModel.fatalErrorAnimationUrl
  };

  /**
   * Gets or sets message of the error.
   */
  public readonly errorMessage = GlobalErrorHandler.fatalError;


  constructor() { }

  ngOnInit(): void {
  }

}
